import script from "./DataValidationValues.vue?vue&type=script&setup=true&lang=js"
export * from "./DataValidationValues.vue?vue&type=script&setup=true&lang=js"

import "./DataValidationValues.vue?vue&type=style&index=0&id=355cb93b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-355cb93b"]])

export default __exports__